import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import * as React from 'react';

export const ConferencesInactiveModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          The Conferences Feature is Not Enabled for this Account Yet.
        </ModalHeader>
        <ModalBody>
          If you&apos;re interested in hosting a conference in Tradewing or
          learning more about the Conferences feature, contact your Customer
          Success Manager or reach out to{' '}
          <a href="mailto:support@tradewing.com">support@tradewing.com</a>.
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>Got it!</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
